import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/7172763fbb93cac028282f1cc3909c2c.png" 
              alt="theintimateedit logo" 
              className="h-16 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <a href="/#about" className="text-charcoal hover:text-coral transition-colors cursor-pointer whitespace-nowrap">About</a>
            <a href="/#packages" className="text-charcoal hover:text-coral transition-colors cursor-pointer whitespace-nowrap">Packages</a>
            <a href="/gallery" className="text-charcoal hover:text-coral transition-colors cursor-pointer whitespace-nowrap">Gallery</a>
            <a href="/#contact" className="text-charcoal hover:text-coral transition-colors cursor-pointer whitespace-nowrap">Contact</a>
          </div>

          <button
            onClick={() => scrollToSection('packages')}
            className="hidden md:block px-6 py-2.5 bg-gradient-to-r from-coral to-pink text-white text-sm font-medium rounded-full hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
          >
            Get Started <i className="ri-sparkling-fill ml-1"></i>
          </button>

          <button className="md:hidden text-charcoal text-xl cursor-pointer">
            <i className="ri-menu-line"></i>
          </button>
        </div>
      </div>
    </motion.nav>
  );
}
